// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const EditSmallHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="16"
            height="16"
            fill="currentColor"
        >
            <path
                d="M1159.55937,626.3175 L1157.68156,624.439375 C1157.09562,623.853437 1156.14437,623.853437 1155.55875,624.439375 L1153.79375,626.206562 L1157.76562,630.206563 L1159.53312,628.439375 C1160.14688,627.853125 1160.14688,626.903438 1159.55937,626.3175 Z M1144.97,635.003125 C1144.90019,635.072938 1144.85263,635.161813 1144.83322,635.258625 L1144.01009,639.37425 C1143.94678,639.690625 1144.19238,640 1144.49844,640 C1144.53122,640 1144.56459,639.996766 1144.59841,639.98999 L1148.71403,639.166865 C1148.81084,639.147518 1148.89969,639.099959 1148.96953,639.03021 L1157.08516,630.914584 L1153.08516,626.914584 L1144.97,635.003125 Z M1148.12188,637.75625 L1145.77375,638.225938 L1146.24344,635.877501 L1147,635.121875 L1147,637 L1148.87875,637 L1148.12188,637.75625 Z"
                transform="translate(-1144 -624)"
            />
        </svg>
    );
};

export default React.memo(EditSmallHover);
